import { render, staticRenderFns } from "./AddCandidateToInterview.vue?vue&type=template&id=488e1e00"
import script from "./AddCandidateToInterview.vue?vue&type=script&lang=js"
export * from "./AddCandidateToInterview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports